import createClient from 'openapi-fetch';
import {
  getPersianErrorMessage,
  getPersianValidationMessage,
} from './persianUi';

// Generated types from openapi.json (run: npm run generate-types)
import type { paths } from '../types/api';

const localizedErrorResponse = async (response: Response) => {
  if (response.ok) return response;

  let payload;
  try {
    payload = await response.clone().json();
  } catch {
    payload = null;
  }

  const message = getPersianErrorMessage({
    ...payload,
    status: response.status,
  });
  const hasDetail = payload && Object.hasOwn(payload, 'detail');
  const detail = Array.isArray(payload?.detail)
    ? payload.detail.map((item) => ({
      ...item,
      msg: getPersianValidationMessage(item),
    }))
    : payload?.detail && typeof payload.detail === 'object'
      ? {
        ...payload.detail,
        message: getPersianErrorMessage({
          code: payload.detail.code ?? payload.code,
          detail: payload.detail.message,
          status: response.status,
        }),
      }
      : message;
  const localizedPayload = {
    ...(payload && typeof payload === 'object' ? payload : {}),
    ...(hasDetail || !payload ? { detail } : {}),
    ...(payload?.code || hasDetail || !payload
      ? { code: payload?.code ?? payload?.detail?.code ?? `HTTP_${response.status}` }
      : {}),
    ...(payload && typeof payload === 'object' ? { message } : { message, code: `HTTP_${response.status}` }),
  };
  const headers = new Headers(response.headers);
  headers.delete('content-length');
  headers.set('content-type', 'application/json; charset=utf-8');
  return new Response(JSON.stringify(localizedPayload), {
    status: response.status,
    statusText: response.statusText,
    headers,
  });
};

const errorResponse = (status: number, code: string, message: string) => new Response(
  JSON.stringify({ detail: message, code, message }),
  {
    status,
    headers: { 'content-type': 'application/json; charset=utf-8' },
  },
);

export const localizedFetch = async (
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> => {
  try {
    return localizedErrorResponse(await fetch(input, init));
  } catch {
    return errorResponse(
      503,
      'NETWORK_ERROR',
      'ارتباط با سرور برقرار نشد. اتصال اینترنت خود را بررسی و دوباره تلاش کنید.',
    );
  }
};

export const apiClient = createClient<paths>({
  baseUrl: '',
  fetch: async (input, init): Promise<Response> => {
    try {
      const request = new Request(input, init);
      const retry = request.clone();
      const response = await fetch(request);
      if (response.status === 403) {
        const payload = await response.clone().json().catch(() => null);
        const errorCode = payload?.code ?? payload?.detail?.code;
        if (errorCode === 'VENDOR_NOT_VERIFIED') {
          return localizedErrorResponse(response);
        }
      }
      if (
        ![401, 403].includes(response.status)
        || new URL(request.url).pathname === '/api/v1/auth/refresh'
      ) {
        return localizedErrorResponse(response);
      }

      const refreshResponse = await fetch('/api/v1/auth/refresh', {
        method: 'POST',
        credentials: 'include',
      });
      return refreshResponse.ok
        ? localizedErrorResponse(await fetch(retry))
        : localizedErrorResponse(response);
    } catch {
      return errorResponse(
        503,
        'NETWORK_ERROR',
        'ارتباط با سرور برقرار نشد. اتصال اینترنت خود را بررسی و دوباره تلاش کنید.',
      );
    }
  },
});

apiClient.use({
  onRequest({ request }) {
    // Authentication is handled by the HttpOnly cookies.
    // The browser automatically sends the shared .lvh.me cookie.
    return new Request(request, {
      credentials: 'include',
    });
  },
});
